<template><div><h1 id="zusagenbeitragbeitrag-erfassen" tabindex="-1"><a class="header-anchor" href="#zusagenbeitragbeitrag-erfassen"><span>Zusagenbeitragbeitrag erfassen</span></a></h1>
<p>Zusagenbeitrag manuell erfassen — zusagenbeitrag in manuellen Buchungen erfassen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Das Erfassen eines Zusagenbeitrages entspricht weitgehend dem <RouteLink to="/referenz/refs/ft.refproc.manbuch_spende.html" title="Spende erfassen">Erfassen einer Spende</RouteLink>. Beim Ereignis wird auf ein Zusagenereignis, Ereignistyp RSB validiert und der Standardvorschlag für das Ereignis wird aus dem Systemparameter <RouteLink to="/referenz/refs/ft.refdata.sysparam.html#ft.x-par.dfex">dfex</RouteLink> vorgeschlagen.</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Buchhaltung → Manuelle Buchungen → Neuer Zusagenbeitrag (Menü)</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Personen-ID</dt>
<dd>Adresse zu der dieser Beitrag gebucht wird</dd>
<dt>Ereignis</dt>
<dd>Auswahl eines <a class="link" href="ft.refdata.ereigkopf.html" title="Ereignisse">Ereignisses</a> und einer <a class="link" href="ft.refdata.ereigpos.html" title="Ereignispositionen">Ereignisposition</a></dd>
<dt>Betrag</dt>
<dd>Zusagenbetrag eintragen</dd>
<dt>Währung</dt>
<dd>Fremdwährung</dd>
<dt>Valutadatum</dt>
<dd>Valutadatum der Buchung</dd>
<dt>Mandant</dt>
<dd>Der <a class="link" href="ft.refdata.tblmandant.html" title="Mandanten">Mandant</a> wird nur eingetragen, wenn er auf Grund der Konteneingabe nicht eindeutig feststellbar ist</dd>
<dt>Konto</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.konti.html" title="Konti">Konto</a></dd>
<dt>Kostenstelle</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.kst.html" title="Kostenstellen">Kostenstelle</a></dd>
<dt>Kostenträger</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.ktr.html" title="Kostenträger">Kostenträger</a></dd>
<dt>Zahlungsnummer</dt>
<dd>Frei definierbare Zahlungsnummer</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>siehe oben</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>siehe oben</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.manbuch.html" title="Manuelle Buchung">Manuelle Buchungen</RouteLink></p>
</div></template>


